@if (enabled) {
  <app-update-policy-status-modal
    [policy]="policy"
    [status]="PolicyStatus.SUSPENDED"
    titleText="Suspendre cette police ?"
    i18n-titleText
    (updateSuccess)="refreshTaskDetails()"
  >
    <app-pause-icon
      height="16px"
      width="16px"
      color="var(--light-gray-500)"
      ngbTooltip="Suspendre la police"
      i18n-ngbTooltip
      trigger
    />
  </app-update-policy-status-modal>
}
